module.exports = __webpack_public_path__ + "static/media/img1.fe4c2c34.jpg";